import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { BrokerDetailsState } from "../../types/broker-details";
import { selectBrokerDetailsState } from "./broker-details.slice";

export const useGetBrokerDetailsState = () => {
  return useSelector<AppStore, BrokerDetailsState>(selectBrokerDetailsState);
};
